import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import { connect } from "react-redux";
import "./StatusList.css";
import { riskIcons } from "../../../shared/riskIcons";
import * as actions from "../../../store/actions/index";

function StatusListInline(props) {
  let arrayOfTotalAlertsPerCategory = [
    { alarmSeverity: "Υψηλού Κινδύνου", total: 0 },
    { alarmSeverity: "Μετρίου Κινδύνου", total: 0 },
    { alarmSeverity: "Χαμηλού Κινδύνου", total: 0 },
    { alarmSeverity: "Χωρίς Κίνδυνο", total: 0 },
    { alarmSeverity: "Συνολικά Σημεία", total: 0 },
  ];

  const { pointsStore, editMapState } = props;

  let totalHighRiskAlerts,
    totalMiddleRiskAlerts,
    totalLowRiskAlerts,
    totalNormal,
    totalAlerts;

  totalHighRiskAlerts = 0;
  totalMiddleRiskAlerts = 0;
  totalLowRiskAlerts = 0;
  totalNormal = 0;
  totalAlerts = 0;

  if (pointsStore) {
    pointsStore.map((point, index) => {
      if (point.highestAlarmSeverity) {
        if (point.highestAlarmSeverity === "High") {
          arrayOfTotalAlertsPerCategory[0].total++;
        } else if (point.highestAlarmSeverity === "Middle") {
          arrayOfTotalAlertsPerCategory[1].total++;
        } else if (point.highestAlarmSeverity === "Low") {
          arrayOfTotalAlertsPerCategory[2].total++;
        }
      } else {
        arrayOfTotalAlertsPerCategory[3].total++;
      }
    });

    totalHighRiskAlerts = arrayOfTotalAlertsPerCategory[0].total;
    totalMiddleRiskAlerts = arrayOfTotalAlertsPerCategory[1].total;
    totalLowRiskAlerts = arrayOfTotalAlertsPerCategory[2].total;
    totalNormal = arrayOfTotalAlertsPerCategory[3].total;
    totalAlerts =
      totalHighRiskAlerts +
      totalMiddleRiskAlerts +
      totalLowRiskAlerts +
      totalNormal;
  }

  const statusIcons = [
    {
      title: arrayOfTotalAlertsPerCategory[0].alarmSeverity,
      total: "Σημεία: " + `${totalHighRiskAlerts}`,
      url: riskIcons[1].options.iconUrl,
      alarmSeverity: "High",
    },
    {
      title: arrayOfTotalAlertsPerCategory[1].alarmSeverity,
      total: "Σημεία: " + `${totalMiddleRiskAlerts}`,
      url: riskIcons[3].options.iconUrl,
      alarmSeverity: "Middle",
    },
    {
      title: arrayOfTotalAlertsPerCategory[2].alarmSeverity,
      total: "Σημεία: " + `${totalLowRiskAlerts}`,
      url: riskIcons[5].options.iconUrl,
      alarmSeverity: "Low",
    },
    {
      title: arrayOfTotalAlertsPerCategory[3].alarmSeverity,
      total: "Σημεία: " + `${totalNormal}`,
      url: riskIcons[0].options.iconUrl,
      alarmSeverity: null,
    },
    {
      title: arrayOfTotalAlertsPerCategory[4].alarmSeverity,
      total: "Ωφελούμενοι: " + `${totalAlerts}`,
      url: riskIcons[7],
      alarmSeverity: null,
    },
  ];

  const filterMapPointsPerRiskFactor = (item) => {
    let filteredPoints;

    if (item.alarmSeverity) {
      filteredPoints = pointsStore.filter((el) => {
        if (el) {
          return el.highestAlarmSeverity == item.alarmSeverity;
        }
      });
    } else if (item.title == "Χωρίς Κίνδυνο") {
      filteredPoints = pointsStore.filter(
        (el) =>el.highestAlarmSeverity == item.alarmSeverity
      );
    } else {
      filteredPoints = pointsStore;
    }

    editMapState({
      filteredPointsStore: filteredPoints,
      isFiltered: true,
    });
  };

  const styles = {
    parentListItem: {
      cursor: "pointer",
    },
    ListItemPrimary: {
      color: "#000",
    },
    ListItemSecondary: {
      color: "#000",
      fontWeight: 900,
    },
  };

  if (
    totalHighRiskAlerts &&
    totalMiddleRiskAlerts &&
    totalLowRiskAlerts &&
    totalNormal
  ) {
  }
  return (
    <List className="StatusListInline">
      {statusIcons.map((item, index) => {
        return (
          <ListItem
            key={index}
            style={styles.parentListItem}
            onClick={() => {
              filterMapPointsPerRiskFactor(item);
            }}
            className="StatusListItem"
          >
            <ListItemAvatar>
              <img src={item.url} alt={item.title} />
            </ListItemAvatar>
            <ListItemText
              className="BlackIcons"
              style={styles.ListItemPrimary}
              primary={<span>{item.title}</span>}
              secondary={
                <span style={styles.ListItemSecondary}>{item.total}</span>
              }
            />
          </ListItem>
        );
      })}
    </List>
  );
}

const mapStateToProps = (state) => {
  return {
    ...state.map,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editMapState: (mapPayload) => {
      dispatch(actions.editMapStateAsync(mapPayload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StatusListInline);
